var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTennis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M99,97.7c-2.9,0-5.2,2.3-5.2,5.2s2.3,5.2,5.2,5.2s5.2-2.3,5.2-5.2S101.9,97.7,99,97.7z M99,105.3c-1.3,0-2.4-1.1-2.4-2.4 s1.1-2.4,2.4-2.4c1.3,0,2.4,1.1,2.4,2.4C101.4,104.2,100.3,105.3,99,105.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3,101.3l25.5-25.5l-7.3-7.3L23.1,94c-2,2-2,5.3,0,7.3C25.1,103.3,28.3,103.3,30.3,101.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6,77.7l-47.3,47.3c-2,2-2,5.3,0,7.3s5.3,2,7.3,0l47.3-47.3L57.6,77.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.7,
    cy: 34.7,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.1,26.2c-2-2.8-4.7-4.1-7.4-4.1s-5.3,1.4-7.4,4.1c-4.1,5.5-4.1,14.5,0,20c1.7,2.3,3.8,3.6,6,4v10.7h-17.1l-49-48.8 c-2-2-5.3-2-7.3,0c-2,2-2,5.3,0,7.3L74,43.1L52.2,64.9l16.4,16.4l21.8-21.8l10.2,10.2c1,1,2.3,1.5,3.6,1.5h20.6 c1.3,0,2.6-0.5,3.7-1.5c2-2,2-5.3,0-7.3c-0.7-0.7-1.5-1.1-2.3-1.3V50.2c2.2-0.4,4.3-1.7,6-4C136.2,40.7,136.2,31.7,132.1,26.2z  M129.9,44.6c-1.4,2-3.3,3-5.2,3c-1.9,0-3.7-1.1-5.2-3c-1.6-2.2-2.5-5.2-2.5-8.4s0.9-6.2,2.5-8.4c1.4-2,3.3-3,5.2-3 c1.9,0,3.7,1.1,5.2,3c1.6,2.2,2.5,5.2,2.5,8.4S131.5,42.4,129.9,44.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTennis);
export default __webpack_public_path__ + "static/media/tennis.2dd8f02e9c0730618e50a601e5b655fc.svg";
export { ForwardRef as ReactComponent };